import withWindowDimensions from 'components/common/withWindowDimensions'
import { LoginProps, withLogin } from 'components/Login/withLogin'
import Button from 'components/LSRevamp/common/Button'
import CardsWithImage from 'components/LSRevamp/common/ExpertCard'
import { cardWithImageItems } from 'components/LSRevamp/CounsellorLandingPage/CounsellorGallerySection/constant'
import { Props } from 'components/LSRevamp/CounsellorLandingPage/CounsellorGallerySection/CounsellorGalleryInterface'
import { ExpertCardItemsType } from 'components/LSRevamp/LSRevampInterfaces'
import { CounsellorSchema } from 'DataMapper/CounsellorPage/CounsellorModel'
import React from 'react'
import Slider, { Settings } from 'react-slick'
import { trackClick } from 'scripts/segment'
import styled from 'styled-components'
import { pageName } from 'utils/events-utils'

const HandleCounsellorsData: React.FC<Props> = ({ ele, index }) => {
  return (
    <CardsWithImage
      key={index}
      image={ele?.image}
      linkedinAddress={ele?.linkedinAddress}
      personName={ele?.personName}
      yearsOfExperience={ele?.yearsOfExperience}
      content={`students counselled. Ensures the right college fit for her students`}
      withExpertise={false}
      numberOfStudents={ele?.numberOfStudents}
      gradientColors={ele?.gradientColors}
    />
  )
}

const CounsellorGallerySection: React.FC<Props & LoginProps> = ({
  isMobileSized,
  counsellors,
  handleSpotCounsellingFlow,
}) => {
  const settings: Settings = {
    dots: true,
    speed: 800,
    slidesToShow: 6,
    slidesToScroll: 1,
    arrows: false,
    autoplaySpeed: 3000,
    autoplay: true,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  }

  const counsellor = counsellors?.filter((ele) => ele.webImage).slice(0, 6)

  if (counsellors?.length === 0) {
    return null
  }

  return (
    <>
      <h2 className="text-xl md:text-[2.625rem] text-center font-bold mt-5 md:mt-[63px]">
        Our Counsellors
      </h2>
      <div className="w-full md:px-[160px] mt-8">
        {!isMobileSized ? (
          counsellors?.length == 0 ? (
            <div className="flex flex-wrap gap-x-[91px] justify-center gap-y-[45px]">
              {cardWithImageItems?.map(
                (ele: ExpertCardItemsType, index: number) => {
                  return (
                    <>
                      <HandleCounsellorsData ele={ele} index={index} />
                    </>
                  )
                },
              )}
            </div>
          ) : (
            <div className="grid grid-cols-3 justify-center gap-x-[91px] gap-y-[45px]">
              {counsellor?.map((ele: CounsellorSchema, index: number) => {
                return (
                  <CardsWithImage
                    key={index}
                    image={ele?.webImage}
                    linkedinAddress={ele?.linkedIn}
                    personName={ele?.name}
                    yearsOfExperience={
                      ele?.yearsOfExperience ? ele?.yearsOfExperience : 1
                    }
                    content={`students counselled. Ensures the right college fit for her students`}
                    withExpertise={false}
                    numberOfStudents={
                      ele?.studentsCounselled
                        ? Number(ele.studentsCounselled)
                        : 1
                    }
                  />
                )
              })}
            </div>
          )
        ) : (
          <div className="w-full">
            {counsellors?.length == 0 ? (
              <StyledSlider {...settings}>
                {cardWithImageItems?.map(
                  (ele: ExpertCardItemsType, index: number) => {
                    return <HandleCounsellorsData ele={ele} key={index} />
                  },
                )}
              </StyledSlider>
            ) : (
              <StyledSlider {...settings}>
                {counsellor?.map((ele: CounsellorSchema, index: number) => {
                  return (
                    <CardsWithImage
                      key={index}
                      image={ele?.webImage}
                      linkedinAddress={ele?.linkedIn}
                      personName={ele?.name}
                      yearsOfExperience={
                        ele?.yearsOfExperience ? ele?.yearsOfExperience : 1
                      }
                      content={`students counselled. Ensures the right college fit for her students`}
                      withExpertise={false}
                      numberOfStudents={
                        ele?.studentsCounselled
                          ? Number(ele?.studentsCounselled)
                          : 1
                      }
                      className="m-auto"
                    />
                  )
                })}
              </StyledSlider>
            )}
          </div>
        )}
      </div>
      <div className="flex flex-row justify-center font-bold md:mt-[35px] mt-[47px] md:mb-[80px] mb-[48px]">
        <Button
          text="Talk to a Counsellor"
          color="text-white"
          backgroundColor="bg-yellow-to-orange"
          width="w-[255px]"
          handleSpotCounsellingFlow={handleSpotCounsellingFlow}
          border="border-0"
          trackingEvent={() => {
            trackClick(pageName.CounsellorPage, {
              contentName: 'Talk to a Counsellor',
              widgetName: 'Counsellor Cards',
              widgetFormat: 'Banner',
              contentFormat: 'Button',
            })
          }}
        />
      </div>
    </>
  )
}

export default withWindowDimensions(withLogin(CounsellorGallerySection))

const StyledSlider = styled(Slider)`
  .slick-initialized {
    display: flex !important;
    justify-content: center !important;
  }

  .slick-slide {
    display: flex !important;
    justify-content: center !important;
  }

  .slick-slide > div {
    display: flex !important;
    justify-content: center !important;
  }

  .slick-initialized > div {
    display: flex !important;
    justify-content: center !important;
  }

  .slick-dots {
    position: absolute;
    bottom: -25px;
  }
  .slick-dots li {
    background: #bdbdbd !important;
    width: 8px !important;
    height: 8px !important;
    border-radius: 100% !important;
    &.slick-active {
      background: #757575 !important;
    }
    & > button:before {
      font-size: 0 !important;
    }
  }
`
